export const FETCH_INTEGRATION_DEVICES = 'FETCH_INTEGRATION_DEVICES';
export const FETCH_INTEGRATION_DEVICES_COUNT = 'FETCH_INTEGRATION_DEVICES_COUNT';
export const CLEAN_INTEGRATIONS = 'CLEAN_INTEGRATIONS';
